module.exports = __webpack_public_path__ + "/img/7bc712daa88f5a32f5c7513b3d43f621.png";